import {EngagementId, TestTemplate} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(engagementId: EngagementId): Promise<TestTemplate[]> {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/engagements/{engagement_id}/test-templates",
    {path: {engagement_id: engagementId}},
  );
}
